import {useCallback} from 'react';
import {generatePath, NavigateOptions, useNavigate} from 'react-router-dom';
import {AnonymousRoutes, AuthRoutes} from './routes';

export const useNavigation = () => {
  const navigate = useNavigate();

  const goToPath = useCallback(
    (path: AuthRoutes | AnonymousRoutes, options?: NavigateOptions) => {
      navigate(path, options);
    },
    [navigate],
  );

  const goToMain = useCallback(
    (options?: NavigateOptions) => {
      navigate(AuthRoutes.MAIN, options);
    },
    [navigate],
  );

  const goToCalendarDetail = useCallback(
    (campaignId: number) => {
      navigate(
        generatePath(AuthRoutes.CALENDAR_DETAIL, {
          campaignId: String(campaignId),
        }),
      );
    },
    [navigate],
  );

  const goToAppointmentsManagement = useCallback(
    (campaignId?: number | string) => {
      navigate(
        generatePath(AuthRoutes.APPOINTMENTS_MANAGEMENT, {
          campaignId: String(campaignId),
        }),
      );
    },
    [navigate],
  );

  const goToSendCampaignInvitation = useCallback(
    (campaignId?: number | string) => {
      navigate(
        generatePath(AuthRoutes.SEND_CAMPAIGN_INVITATION, {
          campaignId: String(campaignId),
        }),
      );
    },
    [navigate],
  );

  const goToAppointmentsRescheduling = useCallback(
    ({
      campaignId,
      appointmentId,
    }: {
      campaignId?: number | string;
      appointmentId?: number | string;
    }) => {
      navigate(
        generatePath(AuthRoutes.APPOINTMENTS_RESCHEDULING, {
          campaignId: String(campaignId),
          appointmentId: String(appointmentId),
        }),
      );
    },
    [navigate],
  );

  const goToAppointmentRequest = useCallback(
    (state: string) => {
      navigate(`${AuthRoutes.APPOINTMENT_REQUEST}?state=${state}`);
    },
    [navigate],
  );

  const goToAppointmentRequestSuccess = useCallback(
    (state: string) => {
      navigate(`${AuthRoutes.APPOINTMENT_REQUEST_SUCCESS}?state=${state}`);
    },
    [navigate],
  );

  const goToAppointmentRescheduleSuccess = useCallback(
    (state: string) => {
      navigate(`${AuthRoutes.APPOINTMENT_RESCHEDULE_SUCCESS}?state=${state}`);
    },
    [navigate],
  );

  return {
    goToPath,
    goToMain,
    goToCalendarDetail,
    goToAppointmentsManagement,
    goToSendCampaignInvitation,
    goToAppointmentsRescheduling,
    goToAppointmentRequest,
    goToAppointmentRequestSuccess,
    goToAppointmentRescheduleSuccess,
  };
};
